import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useParams } from 'react-router-dom'

import { useCompanyInstallationsTableData } from '../hooks'
import { Installation } from 'src/Libs/installations/models/installation.model'
import CompanyApiTableTab from './CompanyApiTableTab'

/**
 * The component provides a list of installations that the company has access to
 */
const CompanyInstallations: React.FC = () => {
  const { t } = useCustomTranslation()
  const { id } = useParams<{ id: string }>()
  const companyId = Number(id)
  const { columns, fetchProps } = useCompanyInstallationsTableData(companyId)

  return (
    <CompanyApiTableTab<Installation>
      columns={columns}
      fetchProps={fetchProps}
      title={t('administration.companies.installations.tab')}
      tabKey={3}
      customNoDataTitle={t('administration.companies.installations.table.noData')}
    />
  )
}

export default CompanyInstallations
